const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

//const Backofficebff         : string = "/backofficebff/service/api/v1";
export const CargoPrioritizationCommand: any = {
    UpdateShippingCompanyRedirectManagement:
        Backofficebff + '/v1/cargopriorty/update-shipping-company-redirect-management',
};
